/*
  rb-size.js — remembers the visitor's size (localStorage rb_size) and highlights it
  in every size chip bar ([data-rb-size-chips] on the homepage, [data-rb-size-bar] in collections).
*/
(function () {
  if (window.__rbSizeInit) return;
  window.__rbSizeInit = true;
  var KEY = 'rb_size';
  function get() { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } }
  function set(v) { try { if (v) window.localStorage.setItem(KEY, v); else window.localStorage.removeItem(KEY); } catch (e) {} }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-rb-size]');
    if (!a) return;
    set(a.getAttribute('data-rb-size'));
  });

  function mark(scope) {
    var mine = get();
    if (!mine) return;
    (scope || document).querySelectorAll('[data-rb-size-chips], [data-rb-size-bar]').forEach(function (bar) {
      if (bar.dataset.rbMarked) return;
      bar.dataset.rbMarked = '1';
      var chip = null;
      bar.querySelectorAll('[data-rb-size]').forEach(function (c) { if (c.getAttribute('data-rb-size') === mine) chip = c; });
      if (!chip || chip.classList.contains('is-active')) return;
      chip.classList.add('is-mine');
      var hint = document.createElement('span');
      hint.className = 'rb-chip__hint';
      hint.textContent = bar.getAttribute('data-mine-label') || '';
      chip.appendChild(hint);
    });
  }

  function boot() {
    mark();
    // Dawn's facets.js swaps #ProductGridContainer via innerHTML — re-mark after updates.
    var grid = document.getElementById('ProductGridContainer');
    if (grid && 'MutationObserver' in window) {
      new MutationObserver(function () { mark(grid); }).observe(grid, { childList: true, subtree: true });
    }
  }
  window.RbSize = { get: get, set: set };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
